import React from 'react';
import DesktopFolderNameCell from 'shared/lib/extendedComponents/grids/components/folderNameCell/desktopFolderNameCell';
import FolderFilesCountCell from 'shared/lib/extendedComponents/grids/components/folderFilesCountCell';
import GridRowContainer from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import DesktopSettingsCell from 'shared/lib/extendedComponents/grids/components/settingsCell/desktopSettingsCell';
import TextCell from 'shared/lib/extendedComponents/grids/components/textCell';
import { observer } from 'mobx-react-lite';
import MobileFolderNameCell from 'shared/lib/extendedComponents/grids/components/folderNameCell/mobileFolderNameCell';
import { ExplorerEntityTypes, ContentFolderItem } from 'entities/types';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import { DateManager } from 'shared/lib/utils/dateManager';
import { noValue } from 'shared/lib/utils/uiConstants';
import ItemSizeCell from '../components/itemSizeCell';

export default observer(function ContentFolderRow({
  onClick,
  onEdit,
  onRestore,
  onDelete,
  isSettingsDisabled,
  supportTypes,
  data,
}: {
  onClick: () => void;
  onEdit?: () => void;
  onRestore?: () => void;
  onDelete?: () => void;
  isSettingsDisabled?: boolean;
  supportTypes: ExplorerEntityTypes[];
  data: ContentFolderItem;
}) {
  const { isLessLaptop } = useBooleanScreens();

  return isLessLaptop ? (
    <GridRowContainer onClick={onClick}>
      <MobileFolderNameCell
        name={data.name}
        filesAmount={data.files_amount}
        updatedAt={data.last_change_date}
      ></MobileFolderNameCell>
      <span></span>
    </GridRowContainer>
  ) : (
    <GridRowContainer onClick={onClick}>
      <DesktopFolderNameCell name={data.name}></DesktopFolderNameCell>
      <TextCell>{new DateManager(data.last_change_date).frontFormat}</TextCell>
      <TextCell>Папка</TextCell>
      <ItemSizeCell></ItemSizeCell>
      {isSettingsDisabled ? (
        <span></span>
      ) : (
        <DesktopSettingsCell
          onSettings={onEdit}
          onRestore={onRestore}
          onDelete={onDelete}
        ></DesktopSettingsCell>
      )}
    </GridRowContainer>
  );
});
